import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import LightBulbHint from 'views/common/components/UI/LightBulbHint';

const StyledBox = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(3),
  color: theme.palette.secondary.main,
  '& .COTableContainer': {
    border: ` 1px solid ${theme.palette.grey[100]}`,
    borderBottom: 'none',
  },
  '& .CRTableCaption': {
    color: theme.palette.secondary.dark,
  },
}));

export const StyledLightBulbHint = styled(LightBulbHint)(({ theme }) => ({
  backgroundColor: 'rgba(243, 224, 94, 0.10)',
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  color: theme.palette.secondary.light,
  marginTop: theme.spacing(3),
}));
export default StyledBox;
